export enum ActionRequiredType {
  None = 'None',
  ConfirmationRequired = 'ConfirmationRequired',
  ApprovalRequired = 'ApprovalRequired',
  AuthorizationRequired = 'AuthorizationRequired',
  NotificationRequired = 'NotificationRequired',
  Prohibit = 'Prohibit',
  InputDataRequired = 'InputDataRequired',
  AgeConfirmationRequired = 'AgeConfirmationRequired',
  ReasonCodeRequired = 'ReasonCodeRequired',
}

export enum AgeConfirmationRejectReason {
  MissingInput = 'MissingInput',
  EndUserRejected = 'EndUserRejected',
  CustomerUnderAge = 'CustomerUnderAge',
}

export enum ApprovalRejectReason {
  ApprovalDataMissing = 'ApprovalDataMissing',
  NotAuthorized = 'NotAuthorized',
}

export enum InputDataType {
  Text = 'Text',
  YesNo = 'YesNo',
  Date = 'Date',
  Birthday = 'Birthday',
  Numeric = 'Numeric',
}

export enum RestrictionOnType {
  /**cart is restricted */
  Cart = 'Cart',

  /**item is restricted */
  Items = 'Items',

  /**void item is restricted */
  VoidItems = 'VoidItems',

  /**tender is restricted */
  Tenders = 'Tenders',

  /**Coupon is restricted */
  Coupons = 'Coupons',
}

export enum RestrictionType {
  OnlineItemAuthorization = 'OnlineItemAuthorization',
  LockForSale = 'LockForSale',
  PriceVerifyRequired = 'PriceVerifyRequired',
  AgeRestriction = 'AgeRestriction',
  PriceModify = 'PriceModify',
  TareModify = 'TareModify',
  LinkItem = 'LinkItem',
  Activity = 'Activity',
  Coupon = 'Coupon',
  CouponLimits = 'CouponLimits',
  CouponOverride = 'CouponOverride',
  Dates = 'Dates',
  FinalizeTransaction = 'FinalizeTransaction',
  ManualInput = 'ManualInput',
  OpenPrice = 'OpenPrice',
  Payment = 'Payment',
  TenderEligibility = 'TenderEligibility',
  TenderEligibilityConflict = 'TenderEligibilityConflict',
  PriceOverride = 'PriceOverride',
  PriceVerify = 'PriceVerify',
  Quantity = 'Quantity',
  RecallTransaction = 'RecallTransaction',
  RemoveLoyaltyCard = 'RemoveLoyaltyCard',
  SellProduct = 'SellProduct',
  SuspendTransaction = 'SuspendTransaction',
  SwitchLoyaltyCard = 'SwitchLoyaltyCard',
  TotalTransaction = 'TotalTransaction',
  UnknownCoupon = 'UnknownCoupon',
  UnpaidTransaction = 'UnpaidTransaction',
  UnusedCoupon = 'UnusedCoupon',
  VoidItem = 'VoidItem',
  VoidTransaction = 'VoidTransaction',
  GiftCardPromotionVoided = 'GiftCardPromotionVoided',
  GenericRuleBehavior = 'GenericRuleBehavior',
  TenderExchange = 'TenderExchange',
  WicItemReturnPolicyBehavior = 'WicItemReturnPolicyBehavior',
  VoucherPayment = 'VoucherPayment',
  PromotionOffline = 'PromotionOffline',
}
